<app-drop-down-universal-sqp *ngIf="tipoDocs.length > 0"
                             [listaDesplegable]="tipoDocs"
                             [tituloDropDown]="'Tipo documento'"
                             (seleccionItemSingleOut)="actualizaFiltroTipoDocumento($event)"
                             [modo]="'single'"
                             [selectedBackgroundColor]="'var(--sqp-yellow1)'"
                             [optionHoverBackgroundColor]="'var(--sqp-yellow2)'"
                             [mostrarTooltipTituloLista]="true"
                             [mostrarIdEnLabel]="false"
                             [permitirQuitarFiltro]="false"
                             [mostrarBuscador]="false"
                             [anchuraDesplegable]="200"
                             ></app-drop-down-universal-sqp>
